var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"custom-btn",attrs:{"to":{ path: _vm.path }}},[_c('img',{attrs:{"src":require("@/assets/images/icons/edit.svg"),"alt":"edit-btn"}})])}
var staticRenderFns = []

export { render, staticRenderFns }